var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM20.7167 14.7649C18.7714 15.574 14.8836 17.2487 9.05315 19.7889C8.10639 20.1654 7.61043 20.5337 7.56528 20.8939C7.48898 21.5025 8.25119 21.7422 9.28912 22.0686C9.43031 22.113 9.57659 22.159 9.72656 22.2077C10.7477 22.5397 12.1214 22.928 12.8355 22.9434C13.4832 22.9574 14.2062 22.6904 15.0044 22.1423C20.4519 18.465 23.264 16.6064 23.4405 16.5663C23.5651 16.538 23.7377 16.5025 23.8546 16.6064C23.9716 16.7104 23.9601 16.9072 23.9477 16.96C23.8722 17.2819 20.8802 20.0636 19.3318 21.503C18.8492 21.9518 18.5068 22.2701 18.4368 22.3428C18.28 22.5056 18.1202 22.6597 17.9666 22.8077C17.0179 23.7223 16.3065 24.4081 18.006 25.528C18.8227 26.0662 19.4762 26.5113 20.1282 26.9553C20.8403 27.4402 21.5505 27.9238 22.4694 28.5262C22.7035 28.6796 22.927 28.839 23.1448 28.9943C23.9735 29.585 24.7179 30.1157 25.6376 30.0311C26.1721 29.9819 26.7241 29.4794 27.0045 27.9806C27.667 24.4386 28.9694 16.7641 29.2704 13.6017C29.2967 13.3246 29.2636 12.97 29.2369 12.8143C29.2103 12.6587 29.1546 12.4369 28.9523 12.2727C28.7127 12.0783 28.3427 12.0373 28.1773 12.04C27.425 12.0534 26.2709 12.4547 20.7167 14.7649Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.ec41c7060e2e49fb1be5655367b58f85.svg";
export { ForwardRef as ReactComponent };